import styled from 'styled-components'

const Main = styled.main`
  padding-top: ${(props) => props.theme.spacing[64]};
`

export default Main
